import React, { FC } from 'react'

type IconProps = {
  className?: string
}

export const PresentationIcon: FC<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill={'none'}
      height={'32'}
      viewBox={'0 0 40 40'}
      width={'32'}
      xmlns={'http://www.w3.org/2000/svg'}
    >
      <path
        d={
          'M3.5 3.98438H36.5C37.3125 3.98438 38 4.67188 38 5.48438C38 6.35938 37.3125 6.98438 36.5 6.98438H3.5C2.625 6.98438 2 6.35938 2 5.48438C2 4.67188 2.625 3.98438 3.5 3.98438ZM4 8.98438H7V22.4844C7 22.7969 7.1875 22.9844 7.5 22.9844H32.5C32.75 22.9844 33 22.7969 33 22.4844V8.98438H36V22.4844C36 24.4219 34.375 25.9844 32.5 25.9844H21.4375V28.9219L26 33.4844C26.625 34.0469 26.625 34.9844 26 35.5469C25.4375 36.1719 24.5 36.1719 23.875 35.5469L19.9375 31.6094L16 35.5469C15.4375 36.1719 14.5 36.1719 13.9375 35.5469C13.3125 34.9844 13.3125 34.0469 13.9375 33.4844L18.5 28.9219V25.9844H7.5C5.5625 25.9844 4 24.4219 4 22.4844V8.98438Z'
        }
        fill={'#141414'}
      />
    </svg>
  )
}
